module.exports = __webpack_public_path__ + "img/25.44b0df1d.jpg";